import {
  CREATE_TYPE_FIELD_FAIL,
  CREATE_TYPE_FIELD_REQUEST,
  CREATE_TYPE_FIELD_SUCCESS,
  FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL,
  FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST,
  FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS,
  FETCH_TYPE_FIELD_FAIL,
  FETCH_TYPE_FIELD_REQUEST,
  FETCH_TYPE_FIELD_SUCCESS,
  FETCH_TYPE_FIELD_VALUE_FAIL,
  FETCH_TYPE_FIELD_VALUE_REQUEST,
  FETCH_TYPE_FIELD_VALUE_SUCCESS,
  SHOW_TYPE_FIELD_FAIL,
  SHOW_TYPE_FIELD_REQUEST,
  SHOW_TYPE_FIELD_SUCCESS,
  UPDATE_TYPE_FIELD_FAIL,
  UPDATE_TYPE_FIELD_REQUEST,
  UPDATE_TYPE_FIELD_SUCCESS,
} from "../../ActionType/TypeFieldTypes/TypeFieldTypes";

export const getTypeFieldReducer = (
  state = { loading: true, typeFields: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_TYPE_FIELD_REQUEST:
      return {
        loading: true,
      };
    case FETCH_TYPE_FIELD_SUCCESS:
      return {
        loading: false,
        typeFields: action.payload,
        error: "",
      };
    case FETCH_TYPE_FIELD_FAIL:
      return {
        loading: false,
        typeFields: [],
        error: action.error,
      };
    default:
      return state;
  }
};
export const getTypeFieldByListNameReducer = (
  state = { loading: true, fieldList: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST:
      return {
        loading: true,
      };
    case FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS:
      return {
        loading: false,
        fieldList: action.payload,
        error: "",
      };
    case FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL:
      return {
        loading: false,
        fieldList: [],
        error: action.error,
      };
    default:
      return state;
  }
};
export const showTypeFieldReducer = (
  state = { loading: true, typeFields: [], error: "" },
  action
) => {
  switch (action.type) {
    case SHOW_TYPE_FIELD_REQUEST:
      return {
        loading: true,
      };
    case SHOW_TYPE_FIELD_SUCCESS:
      return {
        loading: false,
        typeFields: action.payload,
        error: "",
      };
    case SHOW_TYPE_FIELD_FAIL:
      return {
        loading: false,
        typeFields: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const updateTypeFieldReducer = (
  state = { loading: true, typeFields: [], error: "" },
  action
) => {
  switch (action.type) {
    case UPDATE_TYPE_FIELD_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_TYPE_FIELD_SUCCESS:
      return {
        loading: false,
        typeFields: action.payload,
        error: "",
      };
    case UPDATE_TYPE_FIELD_FAIL:
      return {
        loading: false,
        typeFields: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const createTypeFieldReducer = (
  state = { loading: true, typeFields: [], error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_TYPE_FIELD_REQUEST:
      return {
        loading: true,
      };
    case CREATE_TYPE_FIELD_SUCCESS:
      return {
        loading: false,
        typeFields: action.payload,
        error: "",
      };
    case CREATE_TYPE_FIELD_FAIL:
      return {
        loading: false,
        typeFields: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const createTypeFieldValueReducer = (
  state = { loading: true, typeFieldsValues: [], error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_TYPE_FIELD_REQUEST:
      return {
        loading: true,
      };
    case CREATE_TYPE_FIELD_SUCCESS:
      return {
        loading: false,
        typeFieldsValues: action.payload,
        error: "",
      };
    case CREATE_TYPE_FIELD_FAIL:
      return {
        loading: false,
        typeFieldsValues: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const getTypeFieldValueReducer = (
  state = { loading: true, typeFieldValues: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_TYPE_FIELD_VALUE_REQUEST:
      return {
        loading: true,
      };
    case FETCH_TYPE_FIELD_VALUE_SUCCESS:
      return {
        loading: false,
        typeFieldValues: action.payload,
        error: "",
      };
    case FETCH_TYPE_FIELD_VALUE_FAIL:
      return {
        loading: false,
        typeFieldValues: [],
        error: action.error,
      };
    default:
      return state;
  }
};
